import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const ShopIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="30.291" height="30.291" viewBox="0 0 30.291 30.291" {...props}>
    <path
      id="Path_22023"
      data-name="Path 22023"
      d="M30.291,12.621a1.247,1.247,0,0,0-.03-.274L28.62,4.941A6.27,6.27,0,0,0,22.456,0H7.835A6.27,6.27,0,0,0,1.676,4.941L.03,12.347a1.247,1.247,0,0,0-.03.274v1.262a5.028,5.028,0,0,0,1.262,3.336V23.98a6.318,6.318,0,0,0,6.311,6.311H22.718a6.318,6.318,0,0,0,6.311-6.311V17.219a5.028,5.028,0,0,0,1.262-3.336Zm-27.767.138L4.14,5.489a3.764,3.764,0,0,1,3.7-2.965h1V6.311a1.262,1.262,0,0,0,2.524,0V2.524h7.573V6.311a1.262,1.262,0,1,0,2.524,0V2.524h1a3.764,3.764,0,0,1,3.7,2.965l1.616,7.27v1.125a2.524,2.524,0,0,1-2.524,2.524H23.98a2.524,2.524,0,0,1-2.524-2.524,1.262,1.262,0,1,0-2.524,0,2.524,2.524,0,0,1-2.524,2.524H13.883a2.524,2.524,0,0,1-2.524-2.524,1.262,1.262,0,1,0-2.524,0,2.524,2.524,0,0,1-2.524,2.524H5.048a2.524,2.524,0,0,1-2.524-2.524ZM22.718,27.767H7.573A3.786,3.786,0,0,1,3.786,23.98V18.772a5.021,5.021,0,0,0,1.262.16H6.311A5.036,5.036,0,0,0,10.1,17.219a5.036,5.036,0,0,0,3.786,1.713h2.524a5.036,5.036,0,0,0,3.786-1.713,5.036,5.036,0,0,0,3.786,1.713h1.262a5.021,5.021,0,0,0,1.262-.16V23.98A3.786,3.786,0,0,1,22.718,27.767Z"
      transform="translate(0 0)"
      fill="#3477eb"
    />
  </Svg>
));

ShopIcon.displayName = 'ShopIcon';

export default ShopIcon;
